import React from 'react';

const DateBound = ({ label, value, onChange, error }) => {
  const relative = value && typeof value === 'object';
  const days = relative ? value.days_ago ?? '' : '';
  const date = relative ? '' : value || '';

  const setMode = (mode) => onChange(mode === 'days_ago' ? { days_ago: '' } : '');

  return (
    <div>
      <label className='block text-xs font-medium text-slate-500 mb-1'>{label}</label>
      <div className='flex gap-2 min-w-0'>
        <select
          className='shrink-0 shadow-sm border border-slate-300 rounded px-2 py-1.5 text-sm text-slate-700'
          value={relative ? 'days_ago' : 'date'}
          onChange={(e) => setMode(e.target.value)}
        >
          <option value='date'>Date</option>
          <option value='days_ago'>Days ago</option>
        </select>

        {relative ? (
          <input
            type='number'
            min='0'
            className={`flex-1 min-w-0 shadow-sm border rounded px-2 py-1.5 text-sm ${
              error ? 'border-red-400' : 'border-slate-300'
            }`}
            value={days}
            onChange={(e) => onChange({ days_ago: e.target.value })}
            placeholder='days'
          />
        ) : (
          <input
            type='date'
            className={`flex-1 min-w-0 shadow-sm border rounded px-2 py-1.5 text-sm ${
              error ? 'border-red-400' : 'border-slate-300'
            }`}
            value={date}
            onChange={(e) => onChange(e.target.value)}
          />
        )}
      </div>
    </div>
  );
};

export default DateBound;
